module.exports = __webpack_public_path__ + "img/android-icon-36x36.70649a5.png";